var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoHeved(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "76.993752mm",
    height: "74.929008mm",
    viewBox: "0 0 76.993751 74.929008",
    id: "svg1",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-67.890425,-55.387711)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#DC143C",
      fillOpacity: 1,
      strokeWidth: 0.264583
    },
    d: "M 67.890425,60.719737 106.3873,55.387711 V 88.842593 H 95.37527 V 67.642018 l -9.096304,1.216076 v 49.017226 l 9.096304,1.40317 V 97.044676 h 11.01203 v 33.272044 l -38.496875,-5.33203 z",
    id: "path20"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#85182a",
      fillOpacity: 1,
      strokeWidth: 0.264583
    },
    d: "M 144.88418,60.719737 106.3873,55.387711 v 33.454882 h 11.01203 V 67.642018 l 9.0963,1.216076 v 49.017226 l -9.0963,1.40317 V 97.044676 H 106.3873 v 33.272044 l 38.49688,-5.33203 z",
    id: "path22"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 0.264583
    },
    d: "M 106.3873,88.842593 H 95.37527 V 67.642018 l -9.096304,1.216076 v 49.017226 l 9.096304,1.40317 V 97.044676 h 11.01203 v -8.202083",
    id: "path26"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#cdcdcd",
      fillOpacity: 1,
      strokeWidth: 0.264583
    },
    d: "m 106.3873,88.842593 h 11.01203 V 67.642017 l 9.0963,1.216077 v 49.017226 l -9.0963,1.40317 V 97.044676 H 106.3873 v -8.202083",
    id: "path27"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoHeved);
export default __webpack_public_path__ + "static/media/logo-Heved.1149f8f801532a48650fb3f65c37c23c.svg";
export { ForwardRef as ReactComponent };